import { useMemo } from "react";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
	ButtonDropdownMenu,
	type DropdownActionProps,
} from "../components/ButtonDropdownMenu";
import { LinkGen } from "../LinkGen";
import { AppPage } from "../layout/AppLayout";
import { FormPost } from "./FormPost";
import { FormPostProvider, useFormPostContext } from "./FormPostContext";

export type FormPostPageProps = {
	isShorts?: boolean;
};

export const FormPostConsumer = ({ isShorts = false }: FormPostPageProps) => {
	const {
		isPlanPaid,
		handleScheduleClick,
		handlePublishClick,
		handleSaveDraftClick,
		tiktokPublishBlockedReason,
	} = useFormPostContext();

	const publishDisabled = Boolean(tiktokPublishBlockedReason);
	const publishTitle = tiktokPublishBlockedReason;

	const dropdownMenuItems: Array<DropdownActionProps> = useMemo(
		() => [
			{
				label: "Schedule",
				props: {
					onClick: handleScheduleClick,
					disabled: publishDisabled,
					title: publishTitle,
				},
			},
			{
				label: "Publish Now",
				props: {
					onClick: handlePublishClick,
					disabled: publishDisabled,
					title: publishTitle,
				},
			},
			{
				label: "Save",
				props: { onClick: handleSaveDraftClick, icon: "save" },
			},
		],
		[
			handleScheduleClick,
			handlePublishClick,
			handleSaveDraftClick,
			publishDisabled,
			publishTitle,
		],
	);

	return (
		<AppPage
			title={isShorts ? "New YouTube Short" : "Create Post"}
			subtitle={
				isShorts
					? "Upload a vertical video, add metadata, and schedule your Short for YouTube."
					: "Craft your content, pick platforms, and schedule when it goes live."
			}
			headerActions={
				<ButtonDropdownMenu
					main={{
						label: "Schedule",
						props: {
							onClick: handleScheduleClick,
							disabled: publishDisabled,
							title: publishTitle,
						},
					}}
					options={dropdownMenuItems}
				/>
			}
		>
			<p>
				<Link to={LinkGen.Calendar()}>Back to Calendar</Link>
			</p>
			{!isPlanPaid && (
				<Alert variant="warning">
					Posts are not published if you don't have a plan. Please view the{" "}
					<Link to={LinkGen.Settings.Billing()}>Billing Settings here</Link>!
				</Alert>
			)}
			<FormPost />
		</AppPage>
	);
};

export const PagePostCreate = ({ isShorts = false }: FormPostPageProps) => {
	return (
		<FormPostProvider isShorts={isShorts}>
			<FormPostConsumer isShorts={isShorts} />
		</FormPostProvider>
	);
};
